export const DOWNLOAD_PROCESSED = 'DOWNLOAD_PROCESSED';
export const DOWNLOAD_REQUESTED = 'DOWNLOAD_REQUESTED';
export const DOWNLOAD_READY = 'DOWNLOAD_READY';

export const openWindow = function() {
  return window.open("about:blank", "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes");
};

